export default __webpack_public_path__ + "static/media/udemy.919e5296.png";